import { create } from "zustand";
import { getFromLocalStorage, setInLocalStorage } from "../services/localStorageGetSet";

type State = {
  version: string
}

type Action = {
  updateReleaseVersion: (newVersion: State['version']) => void
}

export const useReleaseVersion = create<State & Action>((set) => ({
  version: getFromLocalStorage('releaseVersion'),
  updateReleaseVersion: (newVersion: string) => set(() => {
    setInLocalStorage('version', newVersion)

    return { version: newVersion }
  })
}))